import React from 'react';
import classNames from 'classnames';
import * as PropType from '../common/propType';

import './index.less';

export interface IconPropType extends PropType.RectPropType, PropType.StylePropType {
    src: string;
    circle?: boolean;
    onClick?: () => void;
    prefixCls?: string;
}

class Icon extends React.Component<IconPropType> {
    static defaultProps: IconPropType = {
        src: '',
        circle: false,
        prefixCls: 'icon'
    };

    render() {
        const {src, circle, prefixCls, className, onClick} = this.props;
        let clsName = classNames(prefixCls, {
            [`${prefixCls}-circle`]: circle,
        }, className);
        let style = PropType.getStyle(this.props);
        return (
            <div className={clsName} onClick={onClick} style={style}>
                <img src={src}/>
            </div>
        );
    }
}

export default Icon;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/icon/index.tsx